"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

type Operador = { id: string; nombre: string; rol: string };
type Config = { nombre_marca: string; logo: string | null; color_acento: string };

export default function LoginPage() {
  const router = useRouter();
  const [operadores, setOperadores] = useState<Operador[]>([]);
  const [sel, setSel] = useState<Operador | null>(null);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const [cfg, setCfg] = useState<Config>({ nombre_marca: "Animotion", logo: null, color_acento: "#FA4503" });

  useEffect(() => {
    fetch("/api/operadores/activos").then((r) => r.json())
      .then((d) => setOperadores(d.operadores ?? []))
      .catch(() => setError("No se pudo cargar la lista"));
    fetch("/api/config").then((r) => r.json())
      .then((d) => { if (d.ok) setCfg(d.config); }).catch(() => {});
  }, []);

  const acento = cfg.color_acento || "#FA4503";

  function agregar(d: string) { if (pin.length >= 8) return; setError(""); setPin((p) => p + d); }

  async function entrar() {
    if (!sel || pin.length === 0 || cargando) return;
    setCargando(true); setError("");
    try {
      const r = await fetch("/api/auth/login", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ operador_id: sel.id, pin }),
      });
      const d = await r.json();
      if (d.ok) router.push(d.operador?.rol === "cocina" ? "/cocina" : "/comandas");
      else { setError(d.error ?? "PIN incorrecto"); setPin(""); }
    } catch { setError("Error de conexión"); setPin(""); }
    finally { setCargando(false); }
  }

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          {cfg.logo ? (
            <img src={`/api/imagenes/${cfg.logo}`} alt={cfg.nombre_marca} style={{ maxHeight: 110, maxWidth: "85%", margin: "0 auto", objectFit: "contain" }} />
          ) : (
            <h1 className="text-3xl font-black tracking-tight" style={{ color: acento }}>{cfg.nombre_marca}</h1>
          )}
          <p className="text-sm text-neutral-500 mt-2">Comandas</p>
        </div>

        {!sel ? (
          <div className="space-y-3">
            <p className="text-center text-neutral-400 text-sm mb-2">¿Quién sos?</p>
            {operadores.map((op) => (
              <button key={op.id} onClick={() => setSel(op)}
                className="w-full py-4 px-5 rounded-2xl bg-neutral-900 border border-neutral-800 text-left transition-colors"
                style={{ borderColor: undefined }}
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = acento)}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = "")}>
                <span className="font-semibold">{op.nombre}</span>
                <span className="text-xs text-neutral-500 ml-2 uppercase">{op.rol}</span>
              </button>
            ))}
            {operadores.length === 0 && !error && <p className="text-center text-neutral-600 text-sm">Cargando…</p>}
            {error && <p className="text-center text-red-400 text-sm">{error}</p>}
          </div>
        ) : (
          <div>
            <button onClick={() => { setSel(null); setPin(""); setError(""); }}
              className="text-neutral-500 text-sm mb-4 hover:text-neutral-300">← Cambiar usuario</button>
            <p className="text-center text-lg font-semibold mb-1">{sel.nombre}</p>
            <p className="text-center text-neutral-500 text-xs mb-6">Ingresá tu PIN</p>

            <div className="flex justify-center gap-3 mb-6 h-4">
              {Array.from({ length: Math.max(pin.length, 4) }).map((_, i) => (
                <span key={i} className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: i < pin.length ? acento : "#262626" }} />
              ))}
            </div>

            <div className="grid grid-cols-3 gap-3">
              {["1","2","3","4","5","6","7","8","9"].map((n) => (
                <button key={n} onClick={() => agregar(n)}
                  className="py-5 rounded-2xl bg-neutral-900 border border-neutral-800 text-2xl font-semibold active:bg-neutral-800">{n}</button>
              ))}
              <button onClick={() => setPin((p) => p.slice(0, -1))}
                className="py-5 rounded-2xl text-2xl text-neutral-500 active:bg-neutral-900">←</button>
              <button onClick={() => agregar("0")}
                className="py-5 rounded-2xl bg-neutral-900 border border-neutral-800 text-2xl font-semibold active:bg-neutral-800">0</button>
              <button onClick={entrar} disabled={pin.length === 0 || cargando}
                className="py-5 rounded-2xl text-2xl font-bold disabled:opacity-30 text-white"
                style={{ backgroundColor: acento }}>✓</button>
            </div>

            {error && <p className="text-center text-red-400 text-sm mt-5">{error}</p>}
          </div>
        )}
      </div>
    </main>
  );
}
